import { Link } from "react-router-dom";
import Logo from "../../../assets/icons/KrkLogo.png";

export const KRKLogo = () => {
  return (
    <Link to="/" className="header__krk">
      <img src={Logo} alt="Логотип"></img>
    </Link>
  );
};
